import client from './client';

export const authApi = {
  login: (email, password) =>
    client.post('/auth/login', { email, password }),

  register: (data) =>
    client.post('/auth/register', data),

  refresh: (refreshToken) =>
    client.post('/auth/refresh', { refreshToken }),

  logout: () =>
    client.post('/auth/logout'),

  changePassword: (currentPassword, newPassword) =>
    client.put('/auth/password', { oldPassword: currentPassword, newPassword }),

  me: () =>
    client.get('/auth/me'),

  requestPasswordReset: (email) =>
    client.post('/auth/password-reset', { email }),

  confirmPasswordReset: (token, newPassword) =>
    client.post('/auth/password-reset/confirm', { token, newPassword }),

  // TOTP 2FA
  totpSetup: () =>
    client.post('/auth/totp/setup'),

  totpConfirm: (code) =>
    client.post('/auth/totp/confirm', { code }),

  totpVerify: (totpToken, code) =>
    client.post('/auth/totp/verify', { totpToken, code }),

  totpDisable: (password) =>
    client.post('/auth/totp/disable', { password }),

  totpStatus: () =>
    client.get('/auth/totp/status')
};
